import {FeatureFlags} from '~commonInfra/featureFlags/FeatureFlags';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateUserAuthSettingsParams {
  userIds: string[];
  authSetting: string;
  idpConfigurationName?: string;
  idpConfigurationId?: string;
}

export class UpdateUserAuthSettingsRequest extends Request<IUpdateUserAuthSettingsParams, IResult> {
  constructor(userIds: string[], authSetting: string, idpConfigurationName: string,
              idpConfigurationId: string) {
    super('updateUserAuthSettings', {
      userIds: userIds, authSetting: authSetting,
      idpConfigurationName: FeatureFlags.featureFlagForMultipleIDPSupportEnabled? idpConfigurationName : null,
      idpConfigurationId: FeatureFlags.featureFlagForMultipleIDPSupportEnabled? idpConfigurationId : null
    });
  }
}
